<template>
  <div>
    <toast v-model="showToast" v-if="showToast" :msg="msg"></toast>
  </div>
</template>
<script>
import Toast from '@/components/Toast'
// 用于上报
import { getPromotionDetailForQ } from '@/services/promotion'
import {
  fetchDrawInfo,
  fetchOtherDrawList,
  fetchMyDrawList,
  drawStart,
  saveAddress
} from '@/services/q_prizedraw'
import { loginQ } from '@/utils/q_userinfo'
import { Sniff } from '@/utils/q_sniff'
export default {
  components: {
    Toast
  },
  props: {
    compProps: {
      type: Object,
      default: function() {
        return {}
      }
    },
    payLoad: {
      type: Object,
      default: function() {
        return {}
      }
    },
    compIndex: {
      type: String,
      default: function() {
        return ''
      }
    }
  },
  data() {
    return {
      prizeInfo: {
        // 我的抽奖数据
        myPrize: [],
        // 开始抽奖数据
        allPrize: {},
        // 别人的抽奖数据
        otherPrize: []
      },
      showToast: false,
      firstLogIn: true // 如果是第一次登录要刷新下活动接口 更新抽奖次数
    }
  },
  created() {
    this.initPrize()
  },
  watch: {
    payLoad: {
      handler(newVal) {
        switch (newVal.type) {
        case 'drawprize': // 开始抽奖
          this.drawprize()
          break
        // case 'goUse': // 去哪儿单独逻辑 抽中红包之后有立即使用功能
        //   this.goUse()
        //   break
        case 'setAddress': // 上传邮寄地址信息
          this.setAddress(newVal)
          break
        case 'refreshPrize': // 抽奖完成之后重新打3个接口 刷新抽奖次数 他人抽奖纪录和我的奖品等信息
          setTimeout(() => {
            this.initPrize()
          }, 800)
          break
        default:
        }
      },
      deep: true
    }
  },
  methods: {
    /**
     * 初始化抽奖界面
     */
    initPrize() {
      const { items } = this.compProps.mate || {}
      fetchDrawInfo(items.id).then((res) => {
        if (res && res.value) {
          const data = res.value.data || {}
          this.prizeInfo.allPrize = data || {}
          const { prizeList = [] } = data || {}
          if (prizeList.length) {
            this.prizeInfo.prizeList = this.addDrawBtn(prizeList)
          }
          this.$emit('init', {
            ...this.prizeInfo,
            id: items.id
          })
          if (!this.canDrawPrize()) {
            // 活动未开始时不去请求获奖人员列表
            this.getOtherDrawList(items.id)
          }
          if (Sniff.isLogin) {
            this.getMyDrawList()
          }
        }
      }).catch((e) => {
        console.log(e)
      })
    },
    /**
     * 获取他人获奖列表
     */
    async getOtherDrawList(promotionCode) {
      try {
        const res = await fetchOtherDrawList(promotionCode)
        if (res && res.value && res.value.data) {
          this.prizeInfo.otherPrize = res.value.data
          this.$emit('update', this.prizeInfo)
        }
      } catch (e) {
        console.log(e)
      }
    },
    /**
     * 获取自己的获奖列表
     */
    getMyDrawList() {
      loginQ().then(async() => {
        const { items } = this.compProps.mate || {}
        try {
          const res = await fetchMyDrawList(items.id)
          if (res && res.value && res.value.data) {
            this.prizeInfo.myPrize = res.value.data
            this.$emit('update', this.prizeInfo)
          }
        } catch (e) {
          console.log(e)
        }
      })
    },
    /**
     * 按顺时针方向调整奖品顺序
     */
    dealAllPrizeList(allPrizeList) {
      let oldValue, newValue
      allPrizeList.forEach((prize, index) => {
        if (index === 3) {
          oldValue = prize
          allPrizeList[index] = allPrizeList[8]
        }
        if (index === 5) {
          newValue = prize
          allPrizeList[index] = oldValue
          allPrizeList[8] = newValue
        }
        if (index === 6) {
          newValue = prize
          allPrizeList[index] = allPrizeList[7]
          allPrizeList[7] = newValue
        }
      })
    },
    /**
     * 奖品列表中添加抽奖按钮项:按钮项的prizeType定义为-1
     */
    addDrawBtn(allPrizeList) {
      allPrizeList.splice(4, 0, { prizeType: -1 })
      this.dealAllPrizeList(allPrizeList)
      return allPrizeList
    },
    /**
     * 开始抽奖
     */
    drawprize() {
      if (this.canDrawPrize()) {
        this.doShowToast('当前活动未激活，暂不可进行抽奖')
        this.$emit('finish', { type: 'cantDraw', data: new Date().getTime() })
        return
      }
      loginQ().then(async(res) => {
        const { items } = this.compProps.mate
        // TOB-3521营销会场上报
        getPromotionDetailForQ(this.$root.promotionId)
        try {
          if (this.firstLogIn) {
            this.initPrize()
            this.firstLogIn = false
          }
          const res = await drawStart(items.id)
          if (res && res.value && res.value.data) {
            this.$emit('finish', { type: 'drawFinish', data: res.value.data })
          } else {
            this.$emit('finish', { type: 'cantDraw', data: new Date().getTime() })
            this.doShowToast((res && res.errmsg) || (res && res.value && res.value.errmsg) || '系统开小差了，一会再试试吧')
          }
        } catch (e) {
          this.doShowToast('系统开小差了，一会再试试吧')
          this.$emit('finish', { type: 'cantDraw', data: new Date().getTime() })
          console.log(e)
        }
      }).catch((e) => {
        console.log(e)
        this.$emit('finish', { type: 'cantDraw', data: new Date().getTime() })
        this.doShowToast('请先登录')
      })
    },
    // /**
    //  * 立即使用
    //  */
    // goUse(props) {
    //   const url = getSession(sessionKeys.JUMP_LIST_URL)
    //   setTimeout(() => openScheme(url), 20)
    // },
    /**
     * 上传邮寄地址
     */
    async setAddress(props) {
      try {
        const addressInfo = props.data
        const res = await saveAddress(addressInfo)
        if (res && res.value && res.value.errcode === 0) {
          this.getMyDrawList()
          this.$emit('finish', { type: 'saveFinish', data: new Date().getTime() })
        } else {
          this.doShowToast((res && res.errmsg) || (res && res.value && res.value.errmsg) || '系统开小差了，一会再试试吧')
        }
      } catch (e) {
        this.doShowToast('系统开小差了，一会再试试吧')
        console.log(e)
      }
    },
    /**
     * 判断是否可抽奖
     */
    canDrawPrize() {
      const { startTime, endTime, serverTime } = this.prizeInfo.allPrize
      return (serverTime < startTime || serverTime > endTime)
    },
    /**
     * toast提示
     */
    doShowToast(msg) {
      this.msg = msg
      this.showToast = true
    }
  }
}
</script>
